export default __webpack_public_path__ + "static/media/benefit-map.91ce26a6.png";